export default (superclass) => class extends superclass {
    initialize(models, options = {}) {
        this.searchString = options.searchString || '';
        this.searchableAttributes = [];
        return super.initialize(...arguments);
    }

    search(str = '', options = {}) {
        this.searchString = str;
        return this.fetch(options);
    }

    fetch(options = {}) {
        let where = {or: []};
        if (this.searchString !== '') {
            const escapedString = this.searchString
                .replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
            this.searchableAttributes.forEach(attr => {
                where.or.push({
                    [attr]: {regexp: `/^.*${escapedString}.*$/i`}
                });
            });
        }

        if (!where.or.length) {
            return super.fetch(options);
        }

        where = Object.assign(
            (options.filter && options.filter.where) || {},
            where
        );
        const filter = Object.assign(options.filter || {}, {where});
        return super.fetch(Object.assign({}, options, {filter}));
    }

    getSearchString() {
        return this.searchString;
    }

    getSearchTerm() {
        return this.getSearchString();
    }
};




// WEBPACK FOOTER //
// ./app/new-collections/mixins/searchable.js